enum BlendMode {
  default = 'source-over',
  sourceOver = 'source-over',
  sourceIn = 'source-in',
  sourceOut = 'source-out',
  sourceAtop = 'source-atop',
  destinationOver = 'destination-over',
  destinationIn = 'destination-in',
  destinationOut = 'destination-out',
  destinationAtop = 'destination-atop',
  lighter = 'lighter',
  copy = 'copy',
  xor = 'xor',
  multiply = 'multiply',
  overlay = 'overlay',
  darken = 'darken',
  lighten = 'lighten',
  colorDodge = 'color-dodge',
  colorBurn = 'color-burn',
  hardLight = 'hard-light',
  softLigth = 'soft-light',
  difference = 'difference',
  exclusion = 'exclusion',
  hue = 'hue',
  saturation = 'saturation',
  color = 'color',
  luminosity = 'luminosity',
}

export default BlendMode;
